import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { extractDomain } from "../../utils/helpers";
import { baseQueryWithAuthCheck } from "../../utils/baseQueryWithAuthCheck";
import { endPoints, MIDDLEWARE_SLUG } from "../../apis/apiEndPoints";
import { IRevampServiceResponse } from "../../types/dataTypes";

const DOMAIN = extractDomain();

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithAuthCheck(
    fetchBaseQuery({
      baseUrl: `${window.location.origin}${MIDDLEWARE_SLUG}/middleware`,
    })
  ),
  endpoints: (builder) => ({
    // useGetAuthenticatedUserQuery
    getAuthenticatedUser: builder.query({
      query: () => ({
        url: `${endPoints.AUTHENTICATE_USER}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        params: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

      // useLazyCheckRevampServicesQuery
    checkRevampServices: builder.query<IRevampServiceResponse, number>({
      query: (corpId) => ({
        url: endPoints.CHECK_REVAMP_SERVICE,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        params: {
          corpId,
        },
      }),
    }),
  }),
});

export const { useGetAuthenticatedUserQuery, useLazyCheckRevampServicesQuery } = userApi;
